import MissionSiteEnvironmentChildren from "./mission-site-environment-children";
import MissionSiteVulnerabilityChildren from "./mission-site-vulnerability-children";

const cartography = () =>
  import(
    /* webpackChunkName: "Cartography" */
    "@/components/ssp/missions/mission/site/Cartography.vue"
  );

const securityAccess = () =>
  import(
    /* webpackChunkName: "SecurityAccess" */
    "@/components/ssp/missions/mission/site/SecurityAccess.vue"
  );

const environment = () =>
  import(
    /* webpackChunkName: "Environment" */
    "@/components/ssp/missions/mission/site/Environment.vue"
  );

const testimonials = () =>
  import(
    /* webpackChunkName: "Testimonials" */
    "@/components/ssp/missions/mission/site/Testimonials.vue"
  );

const offSite = () =>
  import(
    /* webpackChunkName: "OffSite" */
    "@/components/ssp/missions/mission/site/OffSite.vue"
  );

const historicalResearch = () =>
  import(
    /* webpackChunkName: "HistoricalResearch" */
    "@/components/ssp/missions/mission/site/HistoricalResearch.vue"
  );

const synthesis = () =>
  import(
    /* webpackChunkName: "Synthesis" */
    "@/components/ssp/missions/mission/site/Synthesis.vue"
  );

const vulnerability = () =>
  import(
    /* webpackChunkName: "Vulnerability" */
    "@/components/ssp/missions/mission/site/Vulnerability.vue"
  );

const referencedDocuments = () =>
  import(
    /* webpackChunkName: "ReferencedDocuments" */
    "@/components/ssp/missions/mission/site/ReferencedDocuments.vue"
  );

export default [
  {
    path: "cartography",
    name: "cartography",
    component: cartography,
    meta: {
      showSubNavBar: true,
      parentRouteName: "site",
    },
  },
  {
    path: "security-access",
    name: "security-access",
    component: securityAccess,
    meta: {
      showSubNavBar: true,
      parentRouteName: "site",
    },
  },
  {
    path: "environment",
    name: "environment",
    component: environment,
    redirect: () => {
      return { name: "OutdoorSpaces" };
    },
    children: MissionSiteEnvironmentChildren,
    meta: {
      showSubNavBar: true,
      parentRouteName: "site",
    },
  },
  {
    path: "testimonials",
    name: "testimonials",
    component: testimonials,
    meta: {
      showSubNavBar: true,
      parentRouteName: "site",
    },
  },
  {
    path: "off-site",
    name: "off-site",
    component: offSite,
    meta: {
      showSubNavBar: true,
      parentRouteName: "site",
    },
  },
  {
    path: "historical-research",
    name: "historical-research",
    component: historicalResearch,
    meta: {
      showSubNavBar: true,
      parentRouteName: "site",
    },
  },
  {
    path: "referenced-documents",
    name: "referenced-documents",
    component: referencedDocuments,
    meta: {
      showSubNavBar: true,
      parentRouteName: "site",
    },
  },
  {
    path: "synthesis",
    name: "synthesis",
    component: synthesis,
    meta: {
      showSubNavBar: true,
      parentRouteName: "site",
    },
  },
  {
    path: "vulnerability",
    name: "vulnerability",
    component: vulnerability,
    redirect: () => {
      return { name: "soil" };
    },
    children: MissionSiteVulnerabilityChildren,
    meta: {
      showSubNavBar: true,
      parentRouteName: "site",
    },
  },
];
